import { Badge, Col, Icon, Input, Radio, Row, Table, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ADD_MED_TO_INVENTORY,
  CLEAR_INVENTORY_MEDICINES,
  CLEAR_PATIENT_PACKET,
  CLEAR_PRESCRIPTION_MEDICINES,
  SET_EXPIRY_DATE,
  SET_INVENTORY_MED,
  SET_ORDERS,
  SET_PARTNERS_LIST,
  SET_PATIENT_PACKET,
  SET_PRESCRIPTION_MEDICINES,
  SET_REQUISITION_MED,
} from "../../ActionTypes/ActionTypes";

// import PackagingToday from './PackagingToday';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { Search } = Input;

class InventoryLandingPage extends Component {
  state = {
    fetching: false,
    selectSearchOption: "name",
    searchValue: "",
  };

  onSearchChange = (event) => {
    this.setState({
      selectSearchOption: event.target.value,
    });
  };

  changeSubmitValue = (event) => {
    this.setState({ searchValue: event.target.value });
  };

  onSearchSubmit = (value) => {
    const { selectSearchOption } = this.state;
    const { setOrders } = this.props;

    this.setState({ fetching: true });
    if (selectSearchOption === "name") {
      axios({
        method: "get",
        url: `orders/search_by_name.json?name=${value}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        setOrders(response.data);
        this.setState({
          fetching: false,
        });
      });
    } else if (selectSearchOption === "mobile") {
      axios({
        method: "get",
        url: `orders/search_by_mobile.json?mobile_number=${value}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        setOrders(response.data);
        this.setState({
          fetching: false,
        });
      });
    }
  };

  loadPrescriptionMeds = async (order_id) => {
    const {
      orders,
      setPrescriptionMeds,
      setInventoryMeds,
      setPatientPacket,
      setExpiryDate,
    } = this.props;

    const order = orders.filter(
      (ord) => Number(ord.id) === Number(order_id)
    )[0];
    console.log(order);

    if (order !== null) {
      const refillID = order.last_refill.id;
      const expiry_date = order.last_refill.carefill_end_date;

      setExpiryDate(expiry_date);

      this.setState({
        loading: true,
      });

      await axios({
        method: "get",
        url: `/carefills/${refillID}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        // console.log(response.data);
        setPrescriptionMeds(response.data.prescription_medicines);

        if (response.data.patient_packet !== undefined) {
          // console.log(response.data.patient_packet);
          setPatientPacket(response.data.patient_packet.id);
          // console.log(response.data.medicine_strips);
          setInventoryMeds(response.data.medicine_strips);
        }
        this.setState({
          loading: false,
        });
      });
    }
  };

  getRequisitionMeds = async (order_id) => {
    const { orders, setRequisitionMeds } = this.props;

    const order = orders.filter(
      (ord) => Number(ord.id) === Number(order_id)
    )[0];

    if (order !== null) {
      const refillID = order.last_refill.id;

      await axios({
        method: "get",
        url: `/requisition_sheet.json?refill_number=${refillID}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        setRequisitionMeds(response.data.sheet_data_array);
      });
    }
  };

  loadPartners = async () => {
    const { setPartnersList } = this.props;

    await axios({
      method: "get",
      url: "/partners.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        const p_locations = [];
        for (let i = 0; i < response.data.length; i++) {
          response.data[i].partner_locations.forEach((location) => {
            p_locations.push(location);
          });
        }
        // console.log(p_locations);
        // this.setState({ partnersList: p_locations });
        setPartnersList(p_locations);
      })
      .catch((error) => {
        alert(
          `Internet Not working, Please check you connection: ${error.code}`
        );
      });
  };

  inventorizeOrder = (order_id) => {
    const {
      history,
      clearPrescriptionMeds,
      clearInventoryMeds,
      clearPatientPacket,
    } = this.props;

    clearPrescriptionMeds();
    clearInventoryMeds();
    clearPatientPacket();

    this.loadPrescriptionMeds(order_id);
    this.loadPartners();
    this.getRequisitionMeds(order_id);
    history.push(`/inventory/${order_id}`);
  };

  render() {
    const { selectSearchOption, searchValue, fetching } = this.state;

    const { orders } = this.props;

    // console.log(orders);

    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        fixed: "left",
        width: 75,
        align: "center",
      },
      {
        title: "Name",
        fixed: "left",
        width: 200,
        render: (record) => (
          <span
            onClick={() =>
              this.handleUserClick(
                record.user.url,
                record.id,
                record.user.id,
                record.start_date,
                record.end_date
              )
            }
            role="button"
          >
            {record.user.is_vip === false ? (
              <a href="">
                {record.user.first_name} {record.user.last_name}
              </a>
            ) : (
              <span>
                <a href="">
                  {record.user.first_name} {record.user.last_name}
                </a>{" "}
                <Badge count="VIP" style={{ backgroundColor: "#52c41a" }} />
              </span>
            )}
            {record.p_prescriptions == null ? (
              ""
            ) : record.p_prescriptions.length > 0 ? (
              <span> (Rx)</span>
            ) : (
              ""
            )}
          </span>
        ),
      },
      {
        title: "Mobile Number",
        dataIndex: "user",
        render: (user) =>
          user.mobile_number == null ? "Not Provided" : `${user.mobile_number}`,
      },
      {
        title: "Location",
        render: (record) => record.partner_location.name,
      },
      {
        title: "Start Date",
        render: (record) =>
          record.carefill_count === 0 ? "Yet to start" : record.start_date,
      },
      {
        title: "Action",
        align: "center",
        render: (record) => (
          <span>
            <Tooltip placement="top" title="Inventorize Order">
              <span
                onClick={() => this.inventorizeOrder(record.id)}
                role="button"
              >
                <a>
                  <Icon type="arrow-right" style={{ color: "blue" }} />
                </a>
              </span>
            </Tooltip>
          </span>
        ),
      },
    ];

    return (
      <div style={{ textAlign: "center" }}>
        <h2>Inventory</h2>
        <hr width="100" />

        <div style={{ height: 20 }} />

        <Row type="flex" justify="center">
          <Col>
            <RadioGroup
              onChange={this.onSearchChange}
              value={selectSearchOption}
            >
              <RadioButton value="name">Name</RadioButton>
              <RadioButton value="mobile">Mobile</RadioButton>
            </RadioGroup>
          </Col>

          <Col style={{ marginLeft: "10px" }}>
            <Search
              className="m-auto"
              enterButton
              value={searchValue}
              onChange={(event) => this.changeSubmitValue(event)}
              placeholder="Name/Mobile"
              onSearch={(value) => this.onSearchSubmit(value)}
              style={{ width: 300 }}
            />
          </Col>
        </Row>

        <div style={{ height: 40 }} />

        <Table
          dataSource={orders}
          columns={columns}
          loading={fetching}
          bordered
          pagination={false}
          size="small"
          rowKey="id"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.InventoryState.orders,
});

const mapDispatchToProps = (dispatch) => ({
  setOrders: (data) =>
    dispatch({ type: SET_ORDERS, payload: { orders: data } }),
  setPrescriptionMeds: (data) =>
    dispatch({ type: SET_PRESCRIPTION_MEDICINES, payload: { meds: data } }),
  setInventoryMeds: (data) =>
    dispatch({ type: SET_INVENTORY_MED, payload: { meds: data } }),
  addMedToInventory: (data) =>
    dispatch({ type: ADD_MED_TO_INVENTORY, payload: { meds: data } }),
  setRequisitionMeds: (data) =>
    dispatch({ type: SET_REQUISITION_MED, payload: { meds: data } }),
  setPatientPacket: (packet_id) =>
    dispatch({ type: SET_PATIENT_PACKET, payload: { packet_id } }),
  setPartnersList: (partners) =>
    dispatch({ type: SET_PARTNERS_LIST, payload: { partners } }),
  clearPrescriptionMeds: () => dispatch({ type: CLEAR_PRESCRIPTION_MEDICINES }),
  clearInventoryMeds: () => dispatch({ type: CLEAR_INVENTORY_MEDICINES }),
  clearPatientPacket: () => dispatch({ type: CLEAR_PATIENT_PACKET }),
  setExpiryDate: (date) =>
    dispatch({ type: SET_EXPIRY_DATE, payload: { date } }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryLandingPage);



// WEBPACK FOOTER //
// ./src/component/Inventory/InventoryLandingPage.js